module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-en-US.88fbc4e8.jpg";